import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-warning",
  "use": "circle-warning-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"circle-warning\"><path d=\"M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m0 12.727A5.734 5.734 0 0 1 1.273 7 5.734 5.734 0 0 1 7 1.273 5.734 5.734 0 0 1 12.727 7 5.734 5.734 0 0 1 7 12.727\" /><path d=\"M7 2.97a.849.849 0 1 0 .002 1.7A.849.849 0 0 0 7 2.969zm0 2.97a.636.636 0 0 0-.636.636v3.818a.637.637 0 0 0 1.272 0V6.576A.637.637 0 0 0 7 5.939z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol